// True when pathname equals href or is nested under it (path-segment boundary).
export function isPathActive(pathname, href) {
  if (!href) return false;
  return pathname === href || pathname.startsWith(href + '/');
}
